import React from 'react';
import { CheckCircle, XCircle, AlertCircle, X } from 'lucide-react';

/**
 * Componente de notificación para mostrar mensajes de éxito, error o info
 */
const FormNotification = ({ type = 'success', message, onClose }) => {
  const styles = {
    success: {
      bg: 'bg-green-50',
      border: 'border-green-500',
      text: 'text-green-800',
      icon: CheckCircle,
      iconColor: 'text-green-500'
    },
    error: {
      bg: 'bg-red-50',
      border: 'border-red-500',
      text: 'text-red-800',
      icon: XCircle,
      iconColor: 'text-red-500'
    },
    info: {
      bg: 'bg-blue-50',
      border: 'border-blue-500',
      text: 'text-blue-800',
      icon: AlertCircle,
      iconColor: 'text-blue-500'
    }
  };

  const config = styles[type] || styles.info;
  const Icon = config.icon;

  return (
    <div 
      className={`${config.bg} ${config.border} border-l-4 p-4 rounded-lg shadow-md animate-fade-in mb-6`}
      role="alert"
    >
      <div className="flex items-start">
        <Icon className={`w-6 h-6 ${config.iconColor} flex-shrink-0`} />
        <div className="ml-3 flex-1">
          <p className={`text-sm font-medium ${config.text}`}>
            {message}
          </p>
        </div>
        {onClose && (
          <button
            onClick={onClose}
            className={`ml-3 ${config.text} hover:opacity-70 transition-opacity`}
            aria-label="Cerrar"
          >
            <X className="w-5 h-5" />
          </button>
        )}
      </div>
    </div>
  );
};

export default FormNotification;
